import { ChatControllerBaseConfig } from '../../../../../base';
import { SolutionContextController } from './solutionContextInterface';

export function createSolutionContextController(
    config: ChatControllerBaseConfig
): SolutionContextController {
    return {
        useProps(context, item, props) {
            return {
                header: {
                    label: 'Solutions',
                },
                search: {
                    input: {
                        placeholder: 'Search solutions...',
                        // Add search functionality later if needed
                    },
                },
                items: item.solutions.map((solution) => ({
                    id: solution.id,
                    label: solution.name,
                    button: {
                        onClick: () => {
                            props.onSelect(solution);
                        },
                    },
                })),
                onBack: props.onBack,
            };
        },
    };
}
